import { format, parseISO, isValid, differenceInDays } from 'date-fns';

export const AVATAR_GRADIENTS = [
  'linear-gradient(135deg, #6366f1, #4f46e5)',
  'linear-gradient(135deg, #06b6d4, #0891b2)',
  'linear-gradient(135deg, #8b5cf6, #6d28d9)',
  'linear-gradient(135deg, #6366f1, #06b6d4)',
  'linear-gradient(135deg, #a855f7, #6366f1)',
  'linear-gradient(135deg, #14b8a6, #6366f1)',
];

export function getInitials(name) {
  if (!name?.trim()) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
  return parts[0].slice(0, 2).toUpperCase();
}

export function getAvatarGradient(name) {
  const code = (name?.trim()?.charCodeAt(0) || 65) % 6;
  return AVATAR_GRADIENTS[code];
}

export function displayRating(value) {
  if (value == null || Number.isNaN(Number(value))) return null;
  const num = Number(value);
  const normalized = num > 10 ? num / 10 : num;
  return normalized;
}

export function formatSalary(expectedSalary, negotiableLabel = 'Negotiable') {
  if (expectedSalary == null || expectedSalary === '') return negotiableLabel;
  const n = Number(expectedSalary);
  if (Number.isNaN(n)) return negotiableLabel;
  if (n >= 100) return `$${Math.round(n / 10)}k`;
  return `₹${n}L`;
}

export function formatAvailabilityDate(availableFrom) {
  if (!availableFrom) return 'Immediately';
  const parsed = parseISO(String(availableFrom));
  if (!isValid(parsed)) return 'Immediately';
  return format(parsed, 'MMM yyyy');
}

export function formatAvailability(availableFrom) {
  return formatAvailabilityLabel(availableFrom);
}

export function isSkillHighlighted(skill, filterSkills = []) {
  if (!filterSkills?.length) return false;
  const lower = skill.toLowerCase();
  return filterSkills.some((f) => f.toLowerCase() === lower);
}

export function formatAvailabilityLabel(availableFrom) {
  const date = availableFrom ? parseISO(String(availableFrom)) : null;
  if (!date || !isValid(date)) {
    return { label: 'Available now', soon: true };
  }
  const days = differenceInDays(date, new Date());
  return {
    label: `Available ${format(date, 'MMM yyyy')}`,
    soon: days <= 30,
  };
}
